export default {
  'fieldEdit.header': 'Edit Question Attribute',
  'fieldEdit.delete': 'Delete',
  'fieldEdit.deleteSuccess': 'Question Attribute deleted successfully!',
  'fieldEdit.editSuccess': 'Question Attribute updated successfully!',
  'fieldEdit.invalidateUpdateOption':
    'The action cannot be performed as the attribute option is associated with a question.',
};
